/* ADD GROUPS */
export const LIST_ANSWERS = "LIST_ANSWERS"
export const LIST_ANSWERS_SUCCESS = "LIST_ANSWERS_SUCCESS"
export const LIST_ANSWERS_CLEAN = "LIST_ANSWERS_CLEAN"
export const LIST_ANSWERS_ERROR = "LIST_ANSWERS_ERROR"
